export const RESET = 'EXCMDEVICESTATE_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICESTATE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICESTATE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICESTATE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICESTATE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICESTATE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICESTATE_UPDATE_UPDATE_RETRIEVED'
